import { showToast, type ActionItem } from 'shared/ui'
import { writeTextToClipboard } from 'shared/lib/writeTextToClipboard'
import { type AuthorizedAppRow } from 'pages/settings/pages/developer/pages/authorizedApps/model/AuthorizedAppRow'
import { type AuthorizedAppsStore } from 'pages/settings/pages/developer/pages/authorizedApps/store/authorizedAppsStore'

const copyToken = async (tokenId: string): Promise<void> => {
  try {
    await writeTextToClipboard(tokenId)
    showToast({ type: 'info', title: 'Copied to clipboard' })
  } catch {
    showToast({ type: 'error', title: 'Failed to copy token' })
  }
}

export const getAuthorizedAppsTableActions = (
  row: AuthorizedAppRow,
  store: AuthorizedAppsStore
): ActionItem[] => [
  {
    icon: 'copy',
    text: 'Copy token',
    onAction: () => copyToken(String(row.id)),
    iconButtonProps: {
      size: 'small',
      fontSize: 16,
      color: 'tertiary',
      ariaLabel: 'Copy token',
    },
  },
  {
    icon: 'delete',
    text: 'Revoke',
    onAction: () => store.openRevokeModal(row.origin),
    iconButtonProps: {
      size: 'small',
      fontSize: 16,
      color: 'tertiary',
      ariaLabel: 'Revoke',
    },
  },
]
